import _ from 'lodash';

import React from 'react';
import { Button } from 'semantic-ui-react';

class AvailableSymbols extends React.Component {
	constructor (props) {
		super(props);

		this.state = {
			symbol: props.symbol,
			symbols: this.props.symbols
		}
	}

	/*componentDidUpdate (prevProps) {
		if (this && this.props.symbol !== prevProps.symbol) {
			this.setState({
				symbol: this.props.symbol
			});
		}
	}*/

	render () {
		const { symbol, symbols } = this.state;

		return (
			<>
				{_.map(this.props.symbols, _symbol => <Button className={`ui ${_symbol === symbol ? 'green' : ''} button`} key={`${_symbol}_ava_button`} compact onClick={() => this.props.changeSymbol(_symbol)}>
					{_symbol}
				</Button>)}
			</>
		)
	}
}

export default AvailableSymbols;

